import { Vec2 } from 'planck-js'
import type { IMessageWriter, IVec2 } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { EPhysicsFutureEventType } from '../physics/golfPhysicsTest'
import { golfPhysicsTest } from '../physics/golfPhysicsTest-sidecar'
import { EGolfMessage } from './golfMessageIds'

export interface IGolfMessagePuckMove {
  pieceId: number
  frame: number
  force: IVec2
  // posx: number
  // posy: number
  // vecx: number
  // vecy: number
}

export const messageId = EGolfMessage.PuckMove

export function write(m: IMessageWriter, d: IGolfMessagePuckMove) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
  messageWriter.write32(m, d.frame)
  messageWriter.writeVec2(m, d.force)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IGolfMessagePuckMove = {
    pieceId: messageWriter.read32(m),
    frame: messageWriter.read32(m),
    force: Vec2(messageWriter.readVec2(m)),
  }

  return d
}

export function test() {
  let ex: IGolfMessagePuckMove = {
    pieceId: 100,
    frame: 235,
    force: { x: 12312.3, y: 0.234 },
  }
  messageWriter.test('puck-move', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  // if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
  //   return
  // }

  //if (!websockets.getIsHost()) {

  golfPhysicsTest.addFutureEvent({
    puckId: msg.pieceId,
    type: EPhysicsFutureEventType.Hit,
    frame: msg.frame,
    force: msg.force,
    pos: { x: 0, y: 0 },
    vel: { x: 0, y: 0 },
  })

  // console.log('got move message', msg.forcex, msg.forcey)

  //}
  // let cp = chessPieces.findByIdSafe(msg.pieceId)

  // // console.log('move to', msg.i, msg.j, cp?.id, cp?.isDead)

  // if (cp && !cp.isDead) {
  //   chessPieces.moveToIJ(cp, msg)
  //   // chessSounds.playPiecePutdown() // Already played by cursor?
  // }
}

export function sendMessageAndImmediatelyExecute(msg: IGolfMessagePuckMove) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
